import React from "react";
import { Link } from "react-router-dom";
import { MY_STORY, IMAGES } from "../../mock.de";
import { Reveal, Eyebrow, Ornament } from "../../components/bits";
import VideoBackground from "../../components/VideoBackground";

const MyStoryDe = () => {
  const { hero, image, opening, paragraphs, signature } = MY_STORY;

  return (
    <main className="video-page">
      <VideoBackground veil={0.55} />
      {/* Intro two-column with portrait */}
      <section className="section bloom" style={{ paddingTop: "clamp(5rem, 9vw, 8rem)" }}>
        <div className="container-page">
          <div className="feature-grid">
            <Reveal>
              <Eyebrow>Meine Geschichte</Eyebrow>
              <h1 className="h-section" style={{ fontSize: "clamp(2rem, 4vw, 3.2rem)" }}>
                {hero.title}
              </h1>
              <p className="h-sub" style={{ marginTop: "1rem" }}>{hero.sub}</p>
            </Reveal>
            <Reveal delay={140} className="feature-media">
              <div className="img-frame" style={{ aspectRatio: "3 / 4", maxWidth: 440, marginLeft: "auto" }}>
                <img src={image} alt="Dr. Ing. Luca Pizzimbone" loading="eager" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Narrative */}
      <section className="section-tight" style={{ paddingTop: 0 }}>
        <div className="container-page">
          <Reveal className="container-narrow prose-body">
            <p>{opening.lead}</p>
            <blockquote className="koan-highlight">
              {opening.highlight.map((line, i) => (
                <span key={i}>{line}</span>
              ))}
            </blockquote>
            <p>{opening.after}</p>
            {paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </Reveal>

          <Reveal className="container-narrow" style={{ textAlign: "center", marginTop: "3rem" }}>
            <Ornament style={{ marginBottom: "1.25rem", justifyContent: "center", display: "inline-flex" }} />
            <div style={{ fontFamily: "var(--font-serif)", fontSize: "1.6rem", color: "var(--ink)" }}>
              {signature.name}
            </div>
            <div className="eyebrow" style={{ marginTop: "0.5rem", color: "var(--gold-strong)" }}>
              {signature.role}
            </div>
          </Reveal>
        </div>
      </section>

      {/* CTA */}
      <section className="section-tight" style={{ background: "var(--paper-warm)" }}>
        <div className="container-page">
          <Reveal className="container-narrow" style={{ textAlign: "center" }}>
            <h2 className="h-section">Gemeinsam im Feld verweilen</h2>
            <p className="lead" style={{ marginTop: "1.25rem" }}>
              Wenn diese Worte etwas Stilles in dir berühren, wäre es mir eine Ehre, diesen Raum mit dir zu halten.
            </p>
            <Link to="/de/kontakt" className="btn-gold" style={{ marginTop: "2rem" }}>
              Tritt in die Kohärenz ein
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default MyStoryDe;
